import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateBrandForm from "../../forms/CreateOrUpdateBrandForm";
import { BrandResponseDto } from "../../shared/dtos/brand/BrandResponseDto";

interface UpdateBrandModalProps {
  open: boolean;
  onClose: () => void;
  brand: BrandResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateBrandModal: React.FC<UpdateBrandModalProps> = ({
  open,
  onClose,
  brand,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit: ${brand.name}`}
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateBrandForm
      isEditing={true}
      brand={brand}
      loading={loading}
      error={error}
    />
  </AppModal>
);
export default UpdateBrandModal;
